<template>
        <div class="loading-wraper">
            <div class="loading">
                <div class="loading--dot"></div>
                <div class="loading--dot"></div>
                <div class="loading--dot"></div>
                <div class="loading--dot"></div>
                <div class="loading--dot"></div>
                <div class="loading--dot"></div>
                <!-- <div class="loading--text"></div> -->
            </div>
        </div>
    </template>
    <script>
        export default {
    
        }
    </script>
    <style scoped>
    .loading-wraper {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 250px;
        height: 25px;
        margin-left: -125px;
    }
    
    .loading {
        height: 20px;
        width: 250px;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        margin: auto;
    }
    .loading--dot {
      animation-name: loading;
      animation-timing-function: ease-in-out;
      animation-duration: 3s;
      animation-iteration-count: infinite;
      height: 20px;
      width: 20px;
      border-radius: 100%;
      background-color: black;
      position: absolute;
      border: 2px solid white;
    }
    .loading--dot:first-child {
      background-color: #FF761C;
      animation-delay: 0.5s;
    }
    .loading--dot:nth-child(2) {
      background-color: #002A56;
      animation-delay: 0.4s;
    }
    .loading--dot:nth-child(3) {
      background-color: #FF761C;
      animation-delay: 0.3s;
    }
    .loading--dot:nth-child(4) {
      background-color: #002A56;
      animation-delay: 0.2s;
    }
    .loading--dot:nth-child(5) {
      background-color: #FF761C;
      animation-delay: 0.1s;
    }
    .loading--dot:nth-child(6) {
      background-color: #002A56;
      animation-delay: 0s;
    }
    .loading--text {
      position: absolute;
      top: 200%;
      left: 0;
      right: 0;
      width: 4rem;
      margin: auto;
    }
    .loading--text:after {
      content: "Loading";
      font-weight: bold;
      animation-name: loading-text;
      animation-duration: 3s;
      animation-iteration-count: infinite;
    }
    
    @keyframes loading {
      15% {
        transform: translateX(0);
      }
      45% {
        transform: translateX(230px);
      }
      65% {
        transform: translateX(230px);
      }
      95% {
        transform: translateX(0);
      }
    }
    @keyframes loading-text {
      0% {
        content: "Loading";
      }
      25% {
        content: "Loading.";
      }
      50% {
        content: "Loading..";
      }
      75% {
        content: "Loading...";
      }
    }
    
    </style>